export const GET_FLEET_CONFIG = '@config/GET_FLEET_CONFIG';
export const SET_FLEET_CONFIG = '@config/SET_FLEET_CONFIG';
